// extracted by mini-css-extract-plugin
export default {"root":"BASADTWk","header":"jpsybngz","headerTitle":"AmHCrjSp","content":"_1E7_8vX","footer":"QQ4ysu2A"};